// // 按需加载iView组件
// import {
//     Button,
//     Table,
//     Page,
//     Modal,
//     Form,
//     Input,
//     Select,
//     Option,
//     DatePicker,
//     FormItem,
//     Message,
//     Menu,
//     MenuItem,
//     Submenu,
//     Icon,
//     Avatar,
//     Steps,
//     Step,
//     Card,
//     Tag,
//     InputNumber,
//     Tooltip,
//     Poptip,
//     Switch,
//     TimePicker,
//     Collapse,
//     Panel,
//     Dropdown,
//     DropdownMenu,
//     Spin,
//     Row,
//     Col,
//     Divider,
//     Tabs,
//     TabPane,
//     Radio,
//     Checkbox,
//     CheckboxGroup,
//     Upload,
//     Tree,
// } from 'view-design';
// Vue.component('Button', Button);
// Vue.component('Table', Table);
// Vue.component('DatePicker', DatePicker);
// Vue.component('Modal', Modal);
// Vue.component('Input', Input);
// Vue.component('Select', Select);
// Vue.component('Option', Option);
// Vue.component('Page', Page);
// Vue.component('Form', Form);
// Vue.component('FormItem', FormItem);
// Vue.component('Message', Message);
// Vue.component('Menu',Menu)
// Vue.component('MenuItem',MenuItem)
// Vue.component('Submenu',Submenu)
// Vue.component('Icon',Icon)
// Vue.component('Avatar',Avatar)
// Vue.component('Steps',Steps)
// Vue.component('Step',Step)
// Vue.component('Card',Card)
// Vue.component('Tag',Tag)
// Vue.component('InputNumber',InputNumber)
// Vue.component('Tooltip',Tooltip)
// Vue.component('Poptip',Poptip)
// Vue.component('Switch',Switch)
// Vue.component('TimePicker',TimePicker)
// Vue.component('Collapse',Collapse)
// Vue.component('Panel',Panel)
// Vue.component('Dropdown',Dropdown)
// Vue.component('DropdownMenu',DropdownMenu)
// Vue.component('Spin',Spin)
// Vue.component('Row',Row)
// Vue.component('Col',Col)
// Vue.component('Divider',Divider)
// Vue.component('Tabs',Tabs)
// Vue.component('TabPane',TabPane)
// Vue.component('Radio',Radio)
// Vue.component('Checkbox',Checkbox)
// Vue.component('CheckboxGroup',CheckboxGroup)
// Vue.component('Upload',Upload)
// Vue.component('Tree',Tree)


// 自定义公用组件，全局可用，页面无需二次引入
import PageTooltip from './common/PageTooltip.vue'
import WupinSelector from './common/WupinSelector.vue'
import CaigoumobanSelector from './common/CaigoumobanSelector.vue'
import ShengchanmobanSelector from './common/ShengchanmobanSelector.vue'
import KucunmobanSelector from './common/KucunmobanSelector.vue'
import CustomTableColumns from './common/CustomTableColumns.vue'
import CustomTable from './common/CustomTable.vue'
import Caozuojilu from './common/Caozuojilu.vue'
import AddressInput from './common/AddressInput.vue'
import XiafaMendianView from './common/XiafaMendianView.vue'
import MendianSelector from './common/MendianSelector.vue'
import ShiyongjigouTable from './common/ShiyongjigouTable.vue'
import Printer from './common/Printer.vue'
import CustomInput from './common/CustomInput.vue'
import Breadcrumb from './common/Layout/breadcrumb/index.vue'
import BaseLayout from './common/Layout/baseLayout.vue'
import BlockLayout from './common/Layout/blockLayout.vue'
import BaseTooltip from './common/BaseTooltip/index.vue'
import BaseForm from './common/BaseForm/index.vue'
import BaseModal from './common/BaseModal/index.vue'
import MoneyTotal from './common/MoneyTotal/index.vue'
import ImgUpload from './common/ImgUpload/index.vue'
import FormDetailLeft from './common/FormDetailLeft/index.vue'
import Searching from './common/Searching/index.vue'
import BaseSelect from './common/BaseSelect/index.vue'
import Vue from 'vue'
import TablePage from './common/TablePage.vue'
import DefaultForm from './common/DefaultForm.vue'
import Uploader from './common/Uploader.vue'
import DataSelector from './common/DataSelector.vue'
import CustomData from './common/CustomData.vue'
import FormItemEditor from './common/FormItemEditor.vue'
import TextList from './common/TextList.vue'

Vue.component('TablePage', TablePage);
Vue.component('DefaultForm', DefaultForm);
Vue.component('Uploader', Uploader);
Vue.component('DataSelector', DataSelector);
Vue.component('CustomData', CustomData);
Vue.component('FormItemEditor', FormItemEditor);
Vue.component('TextList', TextList);
Vue.component('PageTooltip', PageTooltip);
Vue.component('WupinSelector', WupinSelector);
Vue.component('CaigoumobanSelector', CaigoumobanSelector);
Vue.component('KucunmobanSelector', KucunmobanSelector);
Vue.component('ShengchanmobanSelector', ShengchanmobanSelector);
Vue.component('CustomTableColumns', CustomTableColumns);
Vue.component('CustomTable', CustomTable);
Vue.component('Caozuojilu', Caozuojilu);
Vue.component('AddressInput', AddressInput);
Vue.component('XiafaMendianView', XiafaMendianView)
Vue.component('MendianSelector', MendianSelector)
Vue.component('ShiyongjigouTable', ShiyongjigouTable)
Vue.component('Printer', Printer)
Vue.component('CustomInput', CustomInput)
Vue.component('Breadcrumb', Breadcrumb)
Vue.component('BaseLayout', BaseLayout)
Vue.component('BlockLayout', BlockLayout)
Vue.component('BaseTooltip', BaseTooltip)
Vue.component('BaseForm', BaseForm)
Vue.component('BaseModal', BaseModal)
Vue.component('MoneyTotal', MoneyTotal)
Vue.component('FormDetailLeft', FormDetailLeft)
Vue.component('Searching', Searching)
Vue.component('BaseSelect', BaseSelect)
Vue.component('MoneyTotal', MoneyTotal)
Vue.component('ImgUpload', ImgUpload)


// WEBPACK FOOTER //
// ./src/components/index.js